import React, { useEffect, useState } from 'react';
import './About.css';
import { db } from '../firebase';
import { collection, query, orderBy, getDocs } from 'firebase/firestore';

interface Member {
  id: string;
  nome: string;
  filiacao: string;
  localizacao: string;
}

const About: React.FC = () => {
  const [members, setMembers] = useState<Member[]>([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchMembers = async () => {
      try {
        const q = query(collection(db, 'integrantes_giepei'), orderBy('nome', 'asc'));
        const querySnapshot = await getDocs(q);
        const data = querySnapshot.docs.map(doc => ({ id: doc.id, ...doc.data() } as Member));
        setMembers(data);
      } catch (err) {
        console.error('Erro ao buscar integrantes:', err);
      } finally {
        setLoading(false);
      }
    };
    fetchMembers();
  }, []);

  return (
    <div className="about-page">
      <div className="container" style={{ paddingTop: '4rem' }}>
        <h1 className="page-title">Sobre o GIEPEI</h1>
        <div className="underline" style={{ margin: '0 auto 3rem' }}></div>
      </div>

      <section className="about-content container">
        <div className="institutional-text">
          <p className="intro-text">
            O Grupo Internacional de Estudo e Pesquisa em Educação de Infâncias (GIEPEI) é uma rede académica de cooperação científica entre Angola e Brasil dedicada à investigação, formação e inovação na Educação de Infâncias.
          </p>

          <div className="mission-vision-section">
            <div className="text-block">
              <h3>Missão</h3>
              <p>Promover estudos, investigación científica e inovação pedagógica na área da Educación de Infância contribuindo para a formación de profesores, produção de conhecimento educacional e desenvolvimento de prácticas pedagógicas de qualidade, através da cooperação académica entre instituições de Angola e do Brasil.</p>
            </div>
            <div className="text-block">
              <h3>Visão</h3>
              <p>Ser una referência científica internacional na investigación sobre educação de infância, contribuindo para o desenvolvimento educacional, a mejoría das políticas educativas e a formación de profesores comprometidos con a qualidade da educación.</p>
            </div>
          </div>

          <div className="objectives-section">
            <h3>Objectivos Principais</h3>
            <ul className="objectives-list">
              <li>Desenvolver investigación científica conjunta Angola-Brasil;</li>
              <li>Fortalecer a formación inicial e contínua de educadores de infância;</li>
              <li>Promover a inovação pedagógica baseada en evidencias;</li>
              <li>Estimular o intercambio académico entre investigadores, docentes e estudantes;</li>
              <li>Organizar eventos científicos e publicacións especializadas.</li>
            </ul>
          </div>

          <div className="footer-text">
            <p>
              Com sede inicial no Instituto Superior de Ciências da Educação de Luanda <strong>ISCED de Luanda</strong> em Angola e na Universidade Estadual de Campinas <strong>UNICAMP</strong> e Universidade Federal de São Carlos <strong>UFSCar</strong> no Brasil, o GIEPEI reúne actualmente mais de 55 investigadores, professores e profissionais de ambas as nações, com abertura a novas parcerias internacionais.
            </p>
            <p>
              O grupo fundamenta-se nos valores de excelência científica, cooperação, inovação, compromisso social e integridad ética, trabalhando para que a Educación de Infâncias seja reconhecida como etapa fundamental no desenvolvimento humano.
            </p>
          </div>
        </div>
      </section>

      <section className="members-section container">
        <div className="section-header">
          <h2>Nossos Integrantes {members.length > 0 && `(${members.length})`}</h2>
          <div className="underline"></div>
        </div>

        {loading ? (
          <p className="status-message">Carregando lista de integrantes...</p>
        ) : (
          <div className="table-responsive">
            <table className="members-table">
              <thead>
                <tr>
                  <th>Nome Completo</th>
                  <th>Filiação Institucional</th>
                  <th>Província/Estado/País</th>
                </tr>
              </thead>
              <tbody>
                {members.map((member) => (
                  <tr key={member.id}>
                    <td data-label="Nome">{member.nome}</td>
                    <td data-label="Filiação">{member.filiacao}</td>
                    <td data-label="Localização">{member.localizacao}</td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        )}
      </section>
    </div>
  );
};

export default About;
